import style from './index.module.css'

import React from 'react'

import { Flex } from 'components/ds'
import { TagDot } from 'components/search/search-columns/indicators-column/components/tag-dot'
import type { TagWithColor } from 'components/search/search-columns/indicators-column/utils/indicator-colors'
import HighlightedText from 'components/ui/highlighted-text'

import CheckboxRow from '../components/checkbox-row'

type TagsCheckboxProps<T> = {
  tagOptions: T[]
  // Selection identity, id unless more than one tag can share it: playlist
  // tags key by name, so duplicate-named records select together.
  getKey?: (tag: T) => number | string
  onCheckChange: (_checked: string | boolean, _tag: T) => void
  value?: Array<number | string>
  searchValue?: string
}

const TagsCheckbox = <T extends TagWithColor>({
  tagOptions,
  getKey = tag => tag.id,
  onCheckChange,
  value,
  searchValue,
}: TagsCheckboxProps<T>) => {
  return (
    <Flex direction="column" width="100%">
      {tagOptions.map(tag => {
        const key = getKey(tag)
        return (
          <CheckboxRow
            key={tag.id}
            checked={value?.includes(key) ?? false}
            onCheckedChange={checked => onCheckChange(checked, tag)}
            onClick={() => onCheckChange(!value?.includes(key), tag)}
            className={style.Checkbox_RowContainer}
          >
            <Flex align="center" gap="2">
              <TagDot tag={tag} />
              <HighlightedText
                text={tag.name}
                highlights={searchValue ? [searchValue] : []}
                customColors={{
                  background: 'var(--disco-yellow)',
                }}
              />
            </Flex>
          </CheckboxRow>
        )
      })}
    </Flex>
  )
}

export default TagsCheckbox
